import { render, staticRenderFns } from "./NvRechargeCard.vue?vue&type=template&id=1008004f&scoped=true&"
import script from "./NvRechargeCard.vue?vue&type=script&lang=js&"
export * from "./NvRechargeCard.vue?vue&type=script&lang=js&"
import style0 from "./NvRechargeCard.vue?vue&type=style&index=0&id=1008004f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1008004f",
  null
  
)

export default component.exports